import { useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import ReactDOM from 'react-dom';
import './Commons.scss'

export default function RightClickMenuArea({ leftClick, children, menu, leftClickText, draggedReplacementText, ...props }) {
    const [isMenuVisible, setMenuVisible] = useState(false)
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 })
    const [isHover, setIsHover] = useState(false)
    const [replaceLeftClickText, setReplaceLeftClickText] = useState(false)

    function onPointerDown(e) {
        if (e && e.pointerType === 'mouse' && e.button === 2) {
            e.preventDefault();
            setMenuPosition({ top: e.pageY, left: e.pageX });
            setMenuVisible(true);
        } else if (leftClick != undefined) {
            leftClick();
        }
    }

    return (
        <div
            className="right-click w-100 h-100"
            onContextMenu={(e) => {
                e.preventDefault();
            }}
        >
            {children}
            {true && (
                <div className={`left-click-info position-absolute top-0 start-0 h-100 w-100 ${isHover ? "hovered" : ""}`}
                    onPointerDown={onPointerDown}
                    onPointerEnter={() => {
                        setIsHover(true)
                        if (props.cardDraggedRef && props.cardDraggedRef.current) {
                            if (draggedReplacementText) {
                                setReplaceLeftClickText(true)
                            }
                        } 
                    }}
                    onPointerLeave={() => {
                        setIsHover(false)
                        setReplaceLeftClickText(false)
                    }}
                    onPointerUp={() => {
                        setIsHover(false)
                        setReplaceLeftClickText(false)
                    }}
                >
                    <div className="position-absolute top-0 start-0 h-100 w-100"></div>
                    <p className="position-absolute top-0 w-100">{replaceLeftClickText ? draggedReplacementText : leftClickText}</p>
                </div>
            )}
            {isMenuVisible && (<RightClickMenu position={menuPosition} show={isMenuVisible} close={() => setMenuVisible(false)}>
                {menu}
            </RightClickMenu>)}
        </div>
    )
}

export function RightClickMenu({ close, children, ...props }) {
    const menuRef = useRef(null)
    const [correctedPos, setCorrectedPos] = useState(props.position);

    useEffect(() => {
        if (props.show && menuRef.current) {
            const menuRect = menuRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - props.position.top;
            const spaceAbove = props.position.top;
            const menuHeight = menuRect.height || 200; // default guess before rendering

            const shouldFlip = menuHeight > spaceBelow && spaceAbove > spaceBelow;
            let top = shouldFlip
                ? Math.max(props.position.top - menuHeight, 10) // flip above
                : props.position.top;

            let left = Math.min(props.position.left, window.innerWidth - menuRect.width - 10);
            top = shouldFlip ? top + 20 : top - 20
            left = left - menuRect.width / 2
            setCorrectedPos({ top, left });
        }
    }, [props.show]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target) && !(props.additionalOutsideClickCondition && props.additionalOutsideClickCondition.includes(true))) {
                close(); // Only close if click is *outside* the menu
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [props.onClose, props.additionalOutsideClickCondition]);

    const leaveTimeoutRef = useRef(null);

    useEffect(() => {
        return () => {
            if (leaveTimeoutRef.current) {
                clearTimeout(leaveTimeoutRef.current);
            }
        };
    }, []);

    if (!props.show) return null;

    const handleMouseEnter = () => {
        if (leaveTimeoutRef.current) {
            clearTimeout(leaveTimeoutRef.current);
            leaveTimeoutRef.current = null;
        }
    };

    const handleMouseLeave = () => {
        leaveTimeoutRef.current = setTimeout(() => {
            close();
        }, 700);
    };

    return ReactDOM.createPortal(
        <div
            style={{
                position: 'absolute',
                top: correctedPos.top,
                left: correctedPos.left
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <Dropdown.Menu show className="show" ref={menuRef}>
                {children}
            </Dropdown.Menu>
        </div>,
        document.body
    );
}